import React, { FC, SVGProps, useState } from 'react';
import { RecordingStatus } from '@zoom/videosdk';
import { Button, Tooltip } from 'antd';
import LiveIcon from '../../../component/svgs/new/icon-live.svg';
import PlayIcon from '../../../component/svgs/new/icon-play.svg';
import PauseIcon from '../../../component/svgs/new/icon-pause.svg';
import StopIcon from '../../../component/svgs/new/icon-stop.svg';
import RecordAnimateIcon from '../../../component/svgs/icon-recording-animated.svg';

export interface RecordButtonProps {
  isStartingRecording: boolean;
  text: string;
  tipText: string;
  icon: any; // FC<SVGProps<SVGSVGElement>>;
  hoverIcon: string;
  onClick?: () => void;
  isHost?: boolean;
}

export const recordStatusIcon = {
  isStartingRecording: false,
  text: 'Status',
  tipText: 'Record Status',
  icon: RecordAnimateIcon,
  hoverIcon: 'icon-recording-animated-hover',
  isHost: true
};

export const getRecordingButtons = (status: RecordingStatus | '', isHost: boolean) => {
  // Stopped = recording
  // Recording = pause recording/ stop recording
  // Paused = resume recording/ stop recording
  let buttons: RecordButtonProps[] = [];

  if (status === RecordingStatus.Stopped || status === '') {
    buttons = [
      {
        isStartingRecording: false,
        text: 'Record',
        tipText: 'Start Recording',
        icon: LiveIcon,
        hoverIcon: 'icon-recording-hover',
        isHost: isHost
      }
    ];
  } else if (status === RecordingStatus.Recording) {
    if (!isHost) return [recordStatusIcon];
    buttons = [
      recordStatusIcon,
      {
        isStartingRecording: false,
        text: 'Pause',
        tipText: 'Pause Recording',
        icon: PauseIcon,
        hoverIcon: 'icon-recording-pause-hover',
        isHost: isHost
      },
      {
        isStartingRecording: false,
        text: 'Stop',
        tipText: 'Stop Recording',
        icon: StopIcon,
        hoverIcon: 'icon-recording-stop-hover',
        isHost: isHost
      }
    ];
  } else if (status === RecordingStatus.Paused) {
    if (!isHost) return [recordStatusIcon];
    buttons = [
      recordStatusIcon,
      {
        isStartingRecording: false,
        text: 'Resume',
        tipText: 'Resume Recording',
        icon: PlayIcon,
        hoverIcon: 'icon-recording-resume-hover',
        isHost: isHost
      },
      {
        isStartingRecording: false,
        text: 'Stop',
        tipText: 'Stop Recording ?',
        icon: StopIcon,
        hoverIcon: 'icon-recording-stop-hover',
        isHost: isHost
      }
    ];
  }
  return buttons;
};

const RecordingButton = (props: RecordButtonProps) => {
  const { tipText, icon, hoverIcon, onClick, isStartingRecording, isHost } = props;
  return (
    <Tooltip title={tipText}>
      <button
        onClick={onClick}
        style={{
          ...styles.circleBtn
        }}
        className="press-effect-btn"
        title={'Recording'}
      >
        <img
          src={icon}
          alt="magic"
          style={{
            width: 24,
            height: 24
          }}
        />
      </button>
    </Tooltip>
  );
};

export { RecordingButton };

const styles = {
  circleBtn: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    border: 'none',
    background: '#D4183D'
  },
  whiteBtn: {
    background: '#f0f0f0',
    color: '#1a1a1a'
  },
  redBtn: {
    background: '#D4183D',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(192,57,43,0.4)'
  }
};
